export function getImgAltText(name)
{
    const identifier = 'LuxuriaVacations';
    return `${name} ${identifier}`;
}
